import { useEffect, useState } from "react";
import { getMe } from "../lib/api";
import { useApp } from "../store.jsx";
import { Icon } from "./Common.jsx";

// Owner-facing referral link (feature #1). Shows the company's unique code as a
// shareable signup link; new signups via ?ref=CODE record the referrer.
export default function ReferralCard() {
  const { toast } = useApp();
  const [code, setCode] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getMe()
      .then((d) => { if (!cancelled) setCode(d?.company?.referralCode || null); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!code) return null;
  const link = `${window.location.origin}/signup?ref=${code}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast("Referral link copied", "success");
    } catch {
      toast("Copy failed — select and copy manually", "error");
    }
  };

  return (
    <div className="card" style={{ marginTop: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
        <div style={{ width: 36, height: 36, borderRadius: 10, display: "grid", placeItems: "center", background: "rgba(139,92,246,.14)", color: "var(--primary-2)" }}>
          <Icon name="gift" size={18} />
        </div>
        <div>
          <div style={{ fontSize: 15, fontWeight: 700 }}>Refer &amp; share</div>
          <div style={{ fontSize: 12.5, color: "var(--text-muted)" }}>
            Invite other businesses with your unique link.
          </div>
        </div>
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        <input className="input" readOnly value={link} onFocus={(e) => e.target.select()} style={{ flex: "1 1 260px", fontSize: 13 }} />
        <button className="btn btn-primary" onClick={copy}>
          <Icon name="copy" size={14} /> Copy link
        </button>
      </div>
      <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 10 }}>
        Your code: <strong style={{ fontFamily: "monospace", color: "var(--text)" }}>{code}</strong>
      </div>
    </div>
  );
}
